import { createFileRoute, redirect } from '@tanstack/react-router';

// Terms now live as a section of the consolidated /legal page. Keep this URL
// working for old links and bookmarks by redirecting to the anchor.
export const Route = createFileRoute('/terms')({
  beforeLoad: () => {
    throw redirect({ to: '/legal', hash: 'terms' });
  },
});
